<template>
  <div class="template-login" :style="getBgImg(eventInfo)">
    <div class="title">
      <!-- 比赛主视觉 -->
      <img v-if="eventInfo.keyView" class="logo" :src="eventInfo.keyView" />

      <!-- 活动主标题 -->
      <h1 v-for="title in eventInfo.eventTitle.split('\n')" :key="title">{{ $t(title) }}</h1>

      <!-- 活动副标题 -->
      <h2 v-for="title in eventInfo.subTitle.split('\n')" :key="title">{{ $t(title) }}</h2>

    </div>
    <!-- 登录提示 -->
    <h1 v-if="eventInfo.id == null" class="loginTitle">{{$t("Event_Not_Ready")}}</h1>

    <h1 v-if="eventInfo.id" class="loginTitle">{{$t("Login_ICode_Account")}}</h1>
    <!-- 登录表单区域 -->
    <div v-if="eventInfo.id"
      class="loginArea"
      v-loading="loading"
      :element-loading-text='$t("Logging in, please wait...")'
    >
      <div class="userInput">
        <el-form
          ref="userForm"
          :rules="loginRules"
          :model="userForm"
          label-width="120px"
        >
          <el-form-item :label='$t("Account")' prop="name">
            <el-input 
              v-model="userForm.name"
              :placeholder='$t("Please input your account.")'
              width="80%"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item :label='$t("Password")' prop="password"  width="80%">
            <el-input
              v-model="userForm.password"
              :placeholder='$t("Please input your password.")'
              show-password
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="forgetPwd">
          <a @click="tofogot()">{{$t("Forget_Password")}}</a>
        </div>
      </div>
      <!-- 登录和报名按钮 -->
      <div class="btnlist">
        <button v-if="eventInfo.signUpBtn" class="up" @click="toSignup">{{$t("Register")}}</button>
        <button class="up" @click="login('userForm')">{{$t("Login")}}</button>
      </div>
    </div>


    <el-dialog :title="$t('Event_User_Info_Confirmation')" :visible.sync="confirmInfo" class="dialog" center>
      <div class="confirmInfoDialog">

        <el-form :model="userInfo">

				<el-form-item :label='$t("Name")' clearable>
				  <el-input :placeholder='$t("Please input your full name.")' v-model="userInfo.userName" class="w80"></el-input>
				</el-form-item>

				<el-form-item :label='$t("Grade")'  v-if="eventInfo.config.useAge != true">
          <el-select
            id = "gradeSelector"
            v-model="userInfo.grade"
            :placeholder='$t("Please select your current grade.")'
            :disabled="eventInfo.config.gradeDisable"
            @change="gradeChange"
            class="w80"
          >
            <el-option
              v-for="item in gradeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              ></el-option>
				  </el-select>
				</el-form-item>

				<el-form-item :label='$t("Age")' v-else>
          <el-select
            id = "gradeSelector"
            v-model="userInfo.age"
            :placeholder='$t("Please select your age.")'
            @change="ageChange"
            class="w80"
          >
            <el-option
              v-for="item in ageList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              ></el-option>
				  </el-select>
				</el-form-item>

				<el-form-item :label='$t("Group")' label-width="auto">
				<el-select 
					id = "groupSelector"
					v-model="userInfo.gameId"
					:placeholder='$t("Please_Select_Your_Group")'
					clearable
					class="w80"
				>
					<el-option
            v-for="game in eventInfo.eventGames.filter(g => g.minGrade <= parseInt(userInfo.grade) && g.maxGrade >= parseInt(userInfo.grade))"
            :key="game.gameId"
            :label="getGroupName(game)"
            :value="game.gameId"
					></el-option>
				</el-select>
				</el-form-item>

        <el-form-item>
          <el-radio-group v-model="userInfo.gameId" class="gameGroup">
            <el-radio-button
              v-for="game in eventInfo.eventGames.filter(g => g.minGrade <= userInfo.grade && g.maxGrade >= userInfo.grade)"
                :key="game.gameId"
                :label="game.gameId"
                :value="game.gameId"
            >
            <div class="groupOption">
              <img v-if="game.gameId % 100 == 1" src="@/components/contest/assets/blockly_mode_01.png" style="width: 120px;"/>
              <img v-else-if="game.gameId % 100 < 10" src="@/components/contest/assets/blockly_mode_02.png" style="width: 120px;"/>
              <img v-else-if="game.gameId % 100 == 11" src="@/components/contest/assets/python_mode_11.png" style="width: 120px;"/>
              <img v-else src="@/components/contest/assets/python_mode_12.png" style="width: 120px;"/>
              <label>{{ $t(game.aliasName) }}</label>
            </div>
            </el-radio-button>
        </el-radio-group>

				</el-form-item>

        <el-form-item 
          v-if="eventInfo.config.areaIdList"
          class="container-form__regionName" :label='$t("Region")'>
          <el-select 
            v-model="userInfo.areaId"
            @change="change"
            :placeholder='$t("Please_Select_Your_Region")'
            clearable
            filterable
            class="w80"
            >
            <el-option
              v-for="areaId in eventInfo.config.areaIdList"
              :key="areaId"
              :label="$t(Area.getAreaName(areaId))"
              :value="areaId"
            ></el-option>
				  </el-select>
        </el-form-item>

				<el-form-item class="container-form__schoolName" :label='$t("School")'>
					<el-autocomplete
						v-model="userInfo.schoolName"
						:fetch-suggestions="querySearchAsync"
						:trigger-on-focus="false"
						:placeholder='$t("Please enter a school keyword to search.")'
						value-key="schoolCnName"
						@select="changeSchool"
						clearable
            class="w80">
					</el-autocomplete>
				</el-form-item>

				<el-form-item v-if="eventInfo.config.extraInfoTeacherName" :label='$t("Instructor")' clearable>
				  <el-input :placeholder='$t("Instructor_Placeholder")' v-model="userInfo.teacherName" class="w80"></el-input>
				</el-form-item>

				<el-form-item v-if="eventInfo.config.extraInfoTeacherMobile"  :label='$t("Instructor_Contact")' clearable>
				  <el-input :placeholder='$t("Instructor_Contact_Placeholder")' v-model.trim="userInfo.teacherMobile" class="w80"></el-input>
				</el-form-item>

        <el-checkbox-group v-model="userInfo.confirmed" >
          <el-checkbox>{{ $t("Comfirm_My_Event_Info") }}</el-checkbox>
        </el-checkbox-group>

			  </el-form>

        <div class="btnlist" v-show="userInfo.confirmed">
          <button class="up" @click="siguUpEvent()">{{ $t("Confirm") }}</button>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import md5 from "js-md5";
import Common from "@/utils/common";
import { errorInfo } from "@/utils/error";
import { getBgImg, parseEventInfo } from '@/components/contest/template/event';
import * as Area from "@/utils/area.js";

import '@/components/contest/assets/css/template.scss';

export default {
  props:['eventInfo', 'userInfo'],
  data() {
    return {
      Area: Area,
      getBgImg: getBgImg,
      confirmInfo: false,
      gradeList: Common.gradeList(),
      ageList: Common.ageList(),
      loading: false,
      extraInfo: { // 报名所需的额外信息
      },
      // 登录表单
      userForm: {
        name: "",
        password: "",
      },
      loginRules: {
        name: [
          { required: true, message: this.$t("The account cannot be empty."), trigger: "blur" },
        ],
        password: [
          { required: true, message: this.$t("The password cannot be empty."), trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    change(){
    this.$forceUpdate() //其作用就是强制性刷新了一次
    },

    // 按输入的关键词搜索学校
    querySearchAsync(queryString, cb) {
      if (queryString == null || queryString.length < 2) {
        cb([]);
        return;
      }

      this.$http
        .getAxios("/mobile/querySchoolMsg", {
          method: "post",
          params: {
            schoolName: queryString,
            areaId: this.userInfo.areaId,
          }
        })
        .then((res) => {
          var res = res.data;
          if (res.code == "0") {
            var schools = res.data;
            if (schools == null) {
              cb([]);
              return;
            }
            var results = queryString
              ? schools.filter(this.createStateFilter(queryString))
              : schools;
            cb(results);
          } else {
            cb([]);
          }
        });
    },
    // 学校名字替换
    changeSchool(e) {
      this.userInfo.schoolName = e.schoolCnName;
    },

    gradeChange(value) {
      this.userInfo.gameId = undefined;
    },

    ageChange(value) {
      this.userInfo.grade = (this.userInfo.age > 6) ? this.userInfo.age - 6 : 0;
      this.userInfo.gameId = undefined;
    },

    toSignup() {
      this.$router.push({
        path: "/"+ this.eventInfo.channel + "/signup",
      });
    },

    async getExistInfo() {

      let res = await this.$http.getAxios("/user/queryUserInfo");

      // code=0 -> 用户登录成功
      if (res.data.code == "0" && res.data.data) {
        Object.assign(this.userInfo, res.data.data);
        
        this.userInfo.userName = res.data.data.firstName;
        this.userInfo.gameId = undefined;
        this.userInfo.age = parseInt(this.userInfo.grade) + 6;
      } else {
        this.$notify.error({
          title: this.$t("No user information."),
          message: this.$t("User information not found. Please complete the registration first.") ,
        });
        return;
      }

      // 临时增加，限制中国学生参与
      if (this.eventInfo.config && this.eventInfo.config.notAvaiableForChina && Area.isChineseUser(this.userInfo)) {
          this.$notify({
            type: "error",
            title: this.$t("Sorry"),
            message: this.$t("The event is not avaiable for users in China."),
          });
          return;
      }
 
      // 活动限制：特定机构才能进入活动
      if (this.eventInfo.orgIds != null && this.eventInfo.orgIds.length > 0) {
        this.orgIds = this.eventInfo.orgIds.split(",");
        if (this.orgIds.indexOf(this.userInfo.orgId.toString()) == -1) {
          this.$notify({
            type: "error",
            title: this.$t("You cannot participate in the event."),
            message: this.$t("Your management backend is not added to this event. Please contact your account administrator or the event organizer."),
          });
          return;
        }
      }

      this.$notify({
        type: "success",
        title: this.$t("Login_Successfuly"),
        message: this.$t("Event_User_Info_Confirmation"),
      });

      this.confirmInfo = true;
    },

    // 登录方法
    loginBehavior(userForm) {

      if(this.eventInfo.status != 1) {
        this.$notify.error({
          title: this.$t("Event_Not_Ready"),
          message: this.$t("Event_Not_Ready_Message"),
        });
        return;
      }
      
      this.$refs[userForm].validate((valid) => {
        if (valid) {
          this.loading = true;
   
            this.$http.getAxios("/user/channel/userLogin", {
                // 初赛API
                method: "post",
                data: {
                  email: this.userForm.name,
                  password: md5(this.userForm.password),
                  eventCode: this.eventInfo.eventCode,
                },
              }).then((res) => {
                const _res = res.data;
                this.loading = false;

                if (_res.code == "0") {
                  this.$notify({
                    type: "success",
                    title: this.$t("Login successful."),
                  });

                  this.getEventUserInfo();

                // 如果开放报名，则读取用户信息
                } else if (_res.code == "120") {

                  if(this.eventInfo.registerOpen) {

                    this.getExistInfo(); // 获取用户信息，查看是否有报名资格

                  } else {
                    this.$notify({
                      type: "error",
                      title: this.$t("Sorry."),
                      message: errorInfo(_res),
                    });
                  }

                } else {
                  this.$notify({
                    type: "error",
                    title: this.$t("Sorry"),
                    message: errorInfo(_res),
                  });
                }
              });

        } else {
          this.$notify({
            type: "error",
            title: this.$t("Username or password not entered."),
            message: this.$t("Please provide complete account login information."),
          });
        }
      });
    },

    loginWithAccountAndMd5pwd(query) {

      if (this.eventInfo.status != 1) {
        this.$notify.error({
          title: this.$t("Event_Not_Ready"),
          message: this.$t("Event_Not_Ready_Message"),
        });
        return;
      }

      this.loading = true;

      this.$http.getAxios("/user/channel/userLogin", {
        // 初赛API
        method: "post",
        data: {
          email: query.account,
          password: query.md5pwd.toLowerCase(),
          eventCode: this.eventInfo.eventCode,
        },
      }).then((res) => {
        const _res = res.data;
        this.loading = false;

        if (_res.code == "0") {
          this.$notify({
            type: "success",
            title: this.$t("Login successful."),
          });

          this.getEventUserInfo();

          // 如果开放报名，则读取用户信息
        } else if (_res.code == "120") {

          if (this.eventInfo.registerOpen) {

            this.getExistInfo(); // 获取用户信息，查看是否有报名资格

          } else {
            this.$notify({
              type: "error",
              title: this.$t("Sorry."),
              message: errorInfo(_res),
            });
          }

        } else {
          this.$notify({
            type: "error",
            title: this.$t("Sorry"),
            message: errorInfo(_res),
          });
        }
      });
    },

    // 学校名字过滤并替换
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.schoolCnName.toLowerCase().indexOf(queryString.toLowerCase()) >=
          0
        );
      };
    },

    tofogot(){
      window.open('https://home.icode.org.cn/forgotPwd', '_blank')
    },

    siguUpEvent() {
      if(!this.userInfo.gameId) {
        this.$message.error(this.$t("Please_Select_Your_Group"));
        return;
      }

      if (
        this.userInfo.userName == "" ||
        this.userInfo.grade === "" ||
        this.userInfo.schoolName == "" ||
        this.userInfo.gameId == ""
      ) {
        this.$message.error(this.$t("Please complete the registration information."));
        return;
      }

      if (this.userInfo.confirmed == false) {
        this.$message.error(this.$t("Please check to confirm the information."));
        return
      }
      
      // 是否收集额外信息
      let extraInfoMsg = undefined;

      if (this.eventInfo.config) {
        extraInfoMsg = JSON.stringify(this.extraInfo); // 记录额外信息
        if(extraInfoMsg.length < 4) {
          extraInfoMsg = undefined;
        }
      }
      
      this.$http.getAxios("/event/userSignUp", { 
					method: "post",
					data: {
            areaId: this.userInfo.areaId,
						firstName: this.userInfo.userName,
						grade: this.userInfo.grade,
						gameId: this.userInfo.gameId,
						schoolCnName: this.userInfo.schoolName, // 单位名称
						eventCode: this.eventInfo.eventCode,

						teacherName: this.userInfo.teacherName,
						teacherMobile: this.userInfo.teacherMobile,

            extraInfo: extraInfoMsg, 
					},
				}).then((res) => {
					const _res = res.data;
					if(_res.code == "0") {
						sessionStorage.setItem(this.eventInfo.channel + "Login", this.userInfo.gameId);
						sessionStorage.setItem("mode", parseInt(this.userInfo.gameId / 10) % 10);
						sessionStorage.setItem("eventGameList", JSON.stringify(this.eventInfo.eventGames));

						this.$notify.success({
							title: this.$t("Success."),
							message: this.$t("Registration successful!"),
						});
						setTimeout(() => {
              sessionStorage.setItem(`GameId_${this.eventInfo.eventCode}`, this.userInfo.gameId);
							this.$router.push({
								path: "/" + this.eventInfo.channel + "/userIndex"
							});
						}, 500);
					} else if(_res.code == 1) {
						this.$notify.error({
							title: "You have already registered!",
							message: "This account has already registered. Please log in directly to access the competition page.",
						});
						setTimeout(() => {
							this.$router.push({
								path: "/login"
							});
						}, 1000);
					} else {
						this.$notify.error({
							title: this.$t("Error"),
							message: this.$t("Registration failed!") + "Error:" + _res.msg + "Error Code:" + _res.code,
						});
					}
				});
    },

    async getEventUserInfo() {
      let result = false;
      try {
        await this.$http
          .getAxios(`event/getEventUser`, {
            method: "get",
            params: {
              eventCode: this.eventInfo.eventCode, // 预选赛
              competeType: 0, // 此值决定是否决赛，值为0或其他则表示非决赛，1则为决赛
              // mode: 1
            },
          })
          .then((res) => {
            var res = res.data;

            if (res.code == "0") {
              sessionStorage.setItem(`GameId_${this.eventInfo.eventCode}`, res.data.gameId);
              this.$router.push({
                path: "/"+ this.eventInfo.channel + "/userIndex",
              });
            } else {
              // 只要出错就报对应的错误信息
              this.startGameShow = false;
              this.logOutShow = false;

              this.$notify.warning({
                title: this.$t("Sorry"),
                message: errorInfo(res),
              });
            }
          });
      } catch (e) {
        // 若未获取到登录ID信息，弹窗跳转
        this.$notify.error({
          title: this.$t("Sorry"),
          message: "信息：" + e,
        });
      }
      return result;
    },

    async getEventInfo(params) {
      try {
        await this.$http
          .getAxios(`event/getEvent`, {
            method: "get",
            params: params,
          })
          .then((res) => {
            const _res = res.data;

            if (_res.code == 0) {

              Object.assign(this.eventInfo, _res.data);
              parseEventInfo(this.eventInfo);
              this.useAccountAndMd5pwd();
            } else {
              this.$notify.error({
                title: this.$t("Event_Not_Ready"),
                message: this.$t("Event_Not_Ready_Message"),
              });
            }
          });
      } catch (e) {
        console.log(e);
      }
    },

    useAccountAndMd5pwd() {
      const query = this.$route.query;
      if(query.account && query.md5pwd) {
        this.userForm.account = query.account;
        this.loginWithAccountAndMd5pwd(query);
      }
    },

    getGroupName(game) {
      if(this.eventInfo.config.useAge) {
        return this.$t(game.aliasName) + ' ' + this.$t('Age List', {start: game.minGrade+6, end: game.maxGrade+6});
      }

      return this.$t(game.aliasName) + ' ' + this.$t('Grade List', {start: game.minGrade, end: game.maxGrade})
    }
  },

  created() {
    this.login = this.$lodash.throttle(this.loginBehavior, 2000);

    let channel = this.$route.params['channel'];
    if(channel!= this.eventInfo.channel){
      this.getEventInfo({channel: channel});
    } else {
      this.useAccountAndMd5pwd();
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/contest/template/login.vue